<template>
	<div class="main">
		<Header></Header>
		<section class="main-content">
			<div class="content-item">
				<div class="title">属性</div>
				<div class="item-box">
					<!-- <div class="box-left"><请选择产品/服务/项目属性:></div> -->
					<van-radio-group v-model="attribute">
						<div class="box-right">
							<div class="radio-item">
								<van-radio name="1" icon-size="18px" checked-color="#DC394A">产品</van-radio>
							</div>
							<div class="radio-item">
								<van-radio name="2" icon-size="18px" checked-color="#DC394A">服务</van-radio>
							</div>
							<div class="radio-item">
								<van-radio name="3" icon-size="18px" checked-color="#DC394A">项目</van-radio>
							</div>
						</div>
					</van-radio-group>
				</div>
			</div>
			<div class="content-item">
				<div class="title">名称</div>
				<div class="item-box">
					<van-field v-model="title" rows="1" autosize type="textarea" placeholder="<请输入产品/服务/项目名称>" />
				</div>
			</div>
			<div class="content-item">
				<div class="title">品牌</div>
				<div class="item-box">
					<van-field v-model="brand" rows="1" autosize type="textarea" placeholder="<请输入产品/服务/项目品牌>" />
				</div>
			</div>
			<div class="content-item">
				<div class="title">优势&卖点</div>
				<div class="item-box">
					<van-field v-model="advantage" rows="1" autosize type="textarea" placeholder="<请输入产品/服务/项目优势&卖点>" />
				</div>
			</div>
			<div class="identity">
				<div class="title">身份</div>
				<div class="item-box">
					<!-- <div class="box-left"><请选择您的身份></div> -->
					<van-radio-group v-model="identity">
						<div class="box-right">
							<div class="radio-item">
								<van-radio name="1" icon-size="18px" checked-color="#DC394A">生产商</van-radio>
							</div>
							<div class="radio-item">
								<van-radio name="2" icon-size="18px" checked-color="#DC394A">品牌商</van-radio>
							</div>
							<div class="radio-item">
								<van-radio name="3" icon-size="18px" checked-color="#DC394A">贸易商</van-radio>
							</div>
							<div class="radio-item">
								<van-radio name="4" icon-size="18px" checked-color="#DC394A">项目所有方</van-radio>
							</div>
							<div class="radio-item">
								<van-radio name="5" icon-size="18px" checked-color="#DC394A">项目运营方</van-radio>
							</div>
						</div>
					</van-radio-group>
				</div>
			</div>
			<div class="identity">
				<div class="title">图片</div>
				<div class="item-box">
					<div class="box-right">
						<van-uploader v-model="fileList" multiple :after-read="afterRead">
							<van-button icon="plus" type="primary" preview-size="20" lazy-load="true" color="#DC394A"></van-button>
						</van-uploader>
					</div>
				</div>
			</div>
			<div class="btn">
				<button @click="sendForm">立即登记</button>
			</div>
			<div class="tip">
				<div class="tip-title">重要说明:</div>
				<div class="p">1.登记完你可添加微信, /Wechat: <span class="text">zoujindama</span>,及时和我们去的联系，对你所提交的产品/“项目，走进大马仅通过微信/ Wechat给予信息反馈。</div>
				<div class="p">2.补充资料可以添加微信，/Wechat: <span class="text">zoujindama</span>发送，或直接发送到邮箱service@zoujindama.com</div>
			</div>
		</section>
	</div>
</template>

<script>
	import Header from '../components/common/Header.vue'
	import Vue from 'vue'
	import {
		RadioGroup,
		Radio
	} from 'vant';
	import {
		Button
	} from 'vant';
	import {
		Toast
	} from 'vant';
	import {
		Field
	} from 'vant';
	import {
		Uploader
	} from 'vant';

	Vue.use(Uploader);
	Vue.use(Field);
	Vue.use(Toast);
	Vue.use(Button);
	Vue.use(Radio);
	Vue.use(RadioGroup);
	export default {
		data() {
			return {
				userInfo:{},//上个页面传递来的用户信息
				attribute: '1', //登记属性
				name: '', //姓名,
				phone: '', //手机号
				wx: '', //微信号
				title: '', //名称
				brand: '', //品牌
				advantage: '', //优势卖点
				identity: '1', //我的身份
				fileList:[],
				imgList:[],//上传的图片地址
			}
		},
		mounted() {
			this.userInfo = this.$route.query.data
		},
		methods: {
			//点击立即登记
			sendForm(){
				if (this.title === '') {
					Toast.fail('请输入名称');
					return
				}
				if (this.attribute === '') {
					Toast.fail('请输入品牌');
					return
				}
				if (this.brand === '') {
					Toast.fail('请输入品牌');
					return
				}
				if (this.advantage === '') {
					Toast.fail('请输入优势');
					return
				}
				if (this.identity === '') {
					Toast.fail('请选择身份');
					return
				}
				if (this.imgList.length === 0) {
					Toast.fail('请上传图片');
					return
				}
				let imgList = this.imgList;
				let str = imgList.join(",")
				let data = {
					type:this.userInfo.type,
					name:this.userInfo.name,
					mobile:this.userInfo.phone,
					wechat:this.userInfo.wx,
					title:this.title,
					attribute:this.attribute,
					brand:this.brand,
					advantage:this.advantage,
					identity:this.identity,
					image:str
				}
				console.log(data);
				//https://ambang.zonyon.com.cn/api/wxapp.php?i=1&method=tfarticle.business_add
				// let url = `api/wxapp.php?i=1&method=tfarticle.business_add&type=${data.type}&name=${data.name}&mobile=${data.mobile}&mobile=${data.mobile}&wechat=${data.wechat}&title=${data.title}&attribute=${data.attribute}&brand=${data.brand}&advantage=${data.advantage}&identity=${data.identity}&image=${data.image}`
				let url =`https://ambang.zonyon.com.cn/api/wxapp.php?i=1&method=tfarticle.business_add&type=${data.type}&name=${data.name}&mobile=${data.mobile}&mobile=${data.mobile}&wechat=${data.wechat}&title=${data.title}&attribute=${data.attribute}&brand=${data.brand}&advantage=${data.advantage}&identity=${data.identity}&image=${data.image}`;
				this.apiSendForm(url)
			},
			//发送请求的方法
			async apiSendForm(url){
				await this.$axios({
					method:'POST',
					url:url
				}).then(res=>{
					console.log(res)
					if(res.data.result.message === 'success'){
						Toast({
							icon:'success',
							message: '登记成功！',
							duration:2000,
							onClose:()=>{
								this.$router.replace({
									path:'/'
								})
							}
						})
					}
				})
			},
			//上传图片
			afterRead(file) {
				// 此时可以自行将文件上传至服务器
				var fileFile = file.file;
				var formData = new FormData();
				formData.append("file", file.file);
				// let url = `/api`;
				//https://ambang.zonyon.com.cn/api/wxapp.php?i=1&method=center.uploader
				let url = 'https://ambang.zonyon.com.cn/api/wxapp.php?i=1&method=center.uploader'
				this.$axios({
					method:'POST',
					url:url,
					headers: { 'content-type': 'application/x-www-form-urlencoded' },
					data:formData
				}).then(res=>{
					console.log(res.data.result.url)
					let imgList = this.imgList;
					imgList.push(res.data.result.url);
					this.imgList = imgList;
					console.log(this.imgList)
				})
			},
		},
		watch:{
			// fileList(newVal,oldVal){
			// 	let fileList = newVal;
			// 	console.log(fileList)
			// }
		},
		created() {},
		components: {
			Header
		}
	}
</script>

<style scoped="scoped" lang="less">
	.main-content .tip {
		box-sizing: border-box;
		width: 100%;
		padding: 0 30px;
		.tip-title {
			padding: 15px 0;
			font-weight: 600;
		}
		.p {
			color: #787878;
			margin-bottom: 15px;
			.text {
				font-weight: 500;
				font-size: 16px;
				color: #DC394A;
			}
		}
	}
	.main-content .btn {
		box-sizing: border-box;
		width: 100%;
		padding: 0 30px;
		button {
			box-sizing: border-box;
			width: 100%;
			background-color: #DC394A;
			color: #FFFFFF;
			border-radius: 7px;
			padding: 10px 0;
			font-size: 15px;
		}
	}
	.preview-cover {
		position: absolute;
		bottom: 0;
		box-sizing: border-box;
		width: 100%;
		padding: 4px;
		color: #fff;
		font-size: 12px;
		text-align: center;
		background: rgba(0, 0, 0, 0.3);
	}

	.van-cell {
		background-color: #EDEDED;
	}
	.radio-item .radio ::v-deep .van-radio__label {
		font-size: 15px;
	}
	.van-radio {
		font-size: 16px;
	}

	.main {
		width: 100vw;
		height: 100vh;
		overflow-x: hidden;

		.main-content {
			width: 100%;
			padding: 0 30px;
			box-sizing: border-box;
		}
	}

	.main-content .identity {
		margin-bottom: 20px;

		.title {
			font-size: 14px;
		}

		.item-box {
			width: 100%;
			margin-top: 8px;
			background: #EDEDED;
			box-sizing: border-box;
			padding: 20px;
			color: #9E9E9E;
			display: flex;
			align-items: center;

			.box-left {
				width: 28%;
			}

			.box-right {
				width: 100%;
				margin-left: 10px;
				display: flex;
				flex-wrap: wrap;

				.radio-item {
					margin-right: 15px;
					padding: 5px 0;
				}
			}
		}
	}

	.main-content .content-item {
		margin-bottom: 20px;

		.title {
			font-size: 14px;
		}

		.item-box {
			width: 100%;
			margin-top: 8px;
			background: #EDEDED;
			box-sizing: border-box;
			padding: 20px;
			color: #9E9E9E;
			display: flex;
			align-items: center;
			justify-content: center;

			.box-left {
				width: 20%;
			}

			.box-right {
				width: 100%;
				flex: 1;
				margin-left: 10px;
				display: flex;
				align-items: center;
				justify-content: space-around;

				.radio-item {
					width: 33.3333333%;
					margin-right: 15px;
					display: flex;
					align-items: center;
					justify-content: center;
				}
			}
		}
	}
</style>
